var Timeline = function() {

	var total = 0;
	var $width = 0;

	this.init = function() {

		this.timeline();

	};

	this.timeline = function(){

		$('[data-component="timeline"]').find('.column').each(function(){

			$width = $(this).outerWidth();
			total = total + $width;

		});


		if ($(window).width() > 1024) {
			$('[data-component="timeline"] .holder').css('width', total + 50);
			$('.overflow').mCustomScrollbar({
				axis: "x"
			});
		}


	};

	return this.init();

};
